import React from 'react';

const ChecoutHeader = ({ title }) => {
  return (
    <div className="header-block">
      <span>{title}</span>
    </div>
  );
};

export default ChecoutHeader;
